var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.classes,attrs:{"data-src":_vm.url,"alt":_vm.title,"width":_vm.width,"height":_vm.height,"src":"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7","svg-inline":""}})}
var staticRenderFns = []

export { render, staticRenderFns }